
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class sidebarMenu_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `
                <div class="sidebar-nav" data-bind="css: {'is-open': sidebarToggle(), 'is-visible': isVisible()}">
                    <button data-bind="event: { click: closeSidebar }" class="btn-close-default icon i-close" type="button"></button>
                    <ul>
                        <li data-bind="visible: isAccountDetailsVisible() || isUserStatsVisible() || isPropertyManagementVisible() || isSubscriptionManagementVisible() || isSuspiciousRulesVisible()">
                            <label class="icon i-account">Account</label>
                            <ul>
                                <li><a href="/account_settings/" data-bind="visible: isAccountDetailsVisible(), css: {'is-selected': pageSelected() === 'account-settings'}">Account Details</a></li>
                                <li><a href="/account_settings/suspicious_rules/" data-bind="visible: isSuspiciousRulesVisible(), css: {'is-selected': pageSelected() === 'suspicious-rules'}">Suspicious Rules</a></li>
                                <li><a href="/usage_stats/" data-bind="visible: isUserStatsVisible(), css: {'is-selected': pageSelected() === 'usage-stats'}">Pixel Usage</a></li>
                                <li><a href="/property_management/" data-bind="visible: isPropertyManagementVisible(), css: {'is-selected': pageSelected() === 'property-management'}">Property Management</a></li>
                                <li><a href="/subscription_management/" data-bind="visible: isSubscriptionManagementVisible(), css: {'is-selected': pageSelected() === 'subscription-management'}">Subscription Management</a></li>
                            </ul>
                        </li>
                        <li data-bind="visible: isAccountApiVisible()">
                            <label class="icon i-account">API</label>
                            <ul>
                                <li><a class="icon" data-bind="attr: { href: isPlanWithApi() ? '/account_api/' : null }, event: { click: isPlanWithApi() ? null : showPremiumModal.bind($data,'api') },visible: isAccountApiVisible(), css: {'is-selected': pageSelected() === 'account-api', 'is-premium': !isPlanWithApi()}">API Settings</a></li>
                                <li><a class="icon" data-bind="attr: { href: isPlanWithApi() ? '/account_apiUsage/' : null }, event: { click: isPlanWithApi() ? null : showPremiumModal.bind($data,'api') },visible: isAccountApiVisible(), css: {'is-selected': pageSelected() === 'account-apiUsage', 'is-premium': !isPlanWithApi()}">API Usage</a></li>
                            </ul>
                        </li>
                        <li data-bind="visible: isUsersVisible()">
                            <label class="icon i-users">Users</label>
                            <ul>
                                <li><a href="/users/" data-bind="visible: isUsersVisible(), css: {'is-selected': pageSelected() === 'account-users'}">Account Users</a></li>
                            </ul>
                        </li>
                        <li data-bind="visible: isCustomDimensionsVisible() || isCustomEventsVisible()">
                            <label class="icon i-dimensions">Measurables</label>
                            <ul>
                                <li>
                                    <a href="/custom_dimensions/" data-bind="visible: isCustomDimensionsVisible(), css: {'is-selected': pageSelected() === 'custom-dimensions'}">Custom Dimensions</a>
                                </li>
                                <li>
                                    <a class="icon" data-bind="attr: { href: isPlanWithEvents() ? '/custom_events/' : null }, event: { click: isPlanWithEvents() ? null : showPremiumModal.bind($data,'events') }, visible: isCustomEventsVisible(), css: {'is-selected': pageSelected() === 'custom-events', 'is-premium': !isPlanWithEvents()}">Custom Events</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            `;
    }

    protected initPartial():void{

    }

    protected getTemplateName(): string{
        return "sidebarMenu-template";
    }

    protected getMainElementClasses(): Array<string>{
    	return [];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let self = this;
        
        return  {
            sidebarToggle: ko.observable(false),
            pageSelected: ko.observable(),
            isVisible: ko.observable(false),
            isAccountDetailsVisible: ko.observable(false),
            isAccountApiVisible: ko.observable(false),
            isUserStatsVisible: ko.observable(false),
            isPropertyManagementVisible: ko.observable(false),
            isSubscriptionManagementVisible: ko.observable(false),
            isSuspiciousRulesVisible: ko.observable(false),
            isUsersVisible: ko.observable(false),
            isCustomDimensionsVisible: ko.observable(false),
            isCustomEventsVisible: ko.observable(false),
            isPlanWithEvents: ko.observable(false),
            isPlanWithApi: ko.observable(true),
            closeSidebar: function(){
                self.closeSidebar();
            },
            showPremiumModal: function(feature){
                self.showPremiumModal(feature);
            }
        };
    }

    public setData(data){

        let planId = data['planId'];
        let permissions = data['permissions'] || {};
        let isPlanWithEvents = data['isPlanWithEvents'];
        let isPlanWithApi = data['isPlanWithApi'];

        this.getTemplateViewModel().isPlanWithEvents(isPlanWithEvents);
        this.getTemplateViewModel().isPlanWithApi(isPlanWithApi);

        let canShowSuspiciousRules = !!data['canShowSuspiciousRules'];

        if (canShowSuspiciousRules) {

            this.getTemplateViewModel().isVisible(true);
            this.getTemplateViewModel().isSuspiciousRulesVisible(true);
        }

        if(permissions['account_settings_details'] && permissions['account_settings_details']['read']){

            this.getTemplateViewModel().isVisible(true);
            this.getTemplateViewModel().isAccountDetailsVisible(true);
        }

        if(permissions['account_settings_api'] && permissions['account_settings_api']['read']){

            this.getTemplateViewModel().isVisible(true);
            this.getTemplateViewModel().isAccountApiVisible(true);
        }

        if(permissions['account_settings_usage_stats'] && permissions['account_settings_usage_stats']['read']){
            
            this.getTemplateViewModel().isVisible(true);
            this.getTemplateViewModel().isUserStatsVisible(true);
        }
        
        if(permissions['account_settings_property_management'] && permissions['account_settings_property_management']['read']){

            this.getTemplateViewModel().isVisible(true);
            this.getTemplateViewModel().isPropertyManagementVisible(true);
        }

        if(permissions['account_settings_subscription_management'] && permissions['account_settings_subscription_management']['read']) {

            this.getTemplateViewModel().isVisible(true);
            this.getTemplateViewModel().isSubscriptionManagementVisible(true);
        }

        if(permissions['user list'] && permissions['user list']['read']){

            this.getTemplateViewModel().isVisible(true);
            this.getTemplateViewModel().isUsersVisible(true);
        }

        if(permissions['account_settings_custom_dimensions'] && permissions['account_settings_custom_dimensions']['read']){

            this.getTemplateViewModel().isVisible(true);
            this.getTemplateViewModel().isCustomDimensionsVisible(true);
        }

        if(permissions['account_settings_custom_events'] && permissions['account_settings_custom_events']['read']){

            this.getTemplateViewModel().isVisible(true);
            this.getTemplateViewModel().isCustomEventsVisible(true);
        }
    }

    private closeSidebar(){

        this.setSidebarToggle(false);
    }

    private showPremiumModal(feature){
        
        this.caller.showPremiumModal(feature);
    }

    public setSidebarToggle(sidebarToggle) {

        this.getTemplateViewModel().sidebarToggle(sidebarToggle);
    }

    public setPageSelected(pageSelected) {

        this.getTemplateViewModel().pageSelected(pageSelected);
    }

    public setIsVisible(isVisible) {

        this.getTemplateViewModel().isVisible(isVisible);
    }

    public setIsAccountDetailsVisible(isVisible) {

        this.getTemplateViewModel().isAccountDetailsVisible(isVisible);
    }

    public setIsUsersVisible(isVisible) {

        this.getTemplateViewModel().isUsersVisible(isVisible);
    }

    public setIsCustomDimensionsVisible(isVisible) {

        this.getTemplateViewModel().isCustomDimensionsVisible(isVisible);
    }

    public setIsCustomEventsVisible(isVisible) {

        this.getTemplateViewModel().isCustomEventsVisible(isVisible);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/sidebarMenu_template.ts